import React from 'react';
import { useParams } from 'react-router-dom';
import NotFound from '../../components/NotFound.tsx';
import { FeedbackContextProvider } from '../../contexts/feedbacks/feedback.tsx';
import { useUsersContext } from '../../contexts/users.tsx';
import { Role } from '../../models/enums/role.ts';
import FeedbackBody from './body.tsx';
import FeedbackHeader from './header.tsx';

const FeedbackPage = () => {
    const { id } = useParams();
    const userContext = useUsersContext();
    if (id != 'create' && !userContext.isInRole(Role.superAdmin))
        return <NotFound />;

    return (
        <FeedbackContextProvider id={id}>
            <FeedbackHeader />
            <FeedbackBody />
        </FeedbackContextProvider>
    );
};

export default FeedbackPage;
